exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width:900px){.page-card[data-v-2b0285e3]{border-radius:0!important}}@media only print{.app-body[data-v-2b0285e3]{padding:0!important;border-radius:0!important}}.app-body[data-v-2b0285e3]{text-align:center;min-height:100%;width:100%;background-color:#fcfcfd}", ""]);

